import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { Entity } from '../../../../entities/entity';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';

@MergeSchema({
    entity: ActivityEntityName.Contact
})
export class JobPrimaryContactMergeData {
    @MergeField({
        displayName: "Full Name"
    })
    name: string;

    @MergeField()
    email: string;

    @MergeField({
        displayName: "Mobile"
    })
    mobile: string;

    @MergeField({
        displayName: "Work Phone"
    })
    workPhone: string;

    @MergeField({
        displayName: "Home Phone"
    })
    phone: string;
}

export const JobPrimaryContactMergeSchema = getSchema(JobPrimaryContactMergeData);